<template>
  <div class="video-player">
    <video class="video-js" ref="video"></video>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  props: {
    playerOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    onReady(player) {
      this.$emit('ready', player);
    },

    onPlay(player) {
      this.$emit('play', player);
    },

    onPause(player) {
      this.$emit('pause', player);
    },
  },

  mounted() {
    const player = videojs(this.$refs.video, this.playerOptions, () => {
      this.onReady(player);
    });
  },
};
</script>

<style lang="scss">
.video-player {
  // 学院原有对videojs样式的相关调整
  video {
    height: inherit;
    width: inherit;
    outline: none;
  }

  .video-js * {
    color: inherit;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-appearance: none;
    outline: 0;
  }
  .video-js {
    font-size: 14px;
  }

  .vjs-control-bar {
    // 为实现默认展示控制栏，参考学院原有设定，待优化
    display: flex !important;
  }
  .vjs-picture-in-picture-control {
    // 隐藏画中画功能
    display: none !important;
  }
  .vjs-playback-rate .vjs-playback-rate-value {
    font-size: 1em;
    line-height: 3;
  }
  .vjs-playback-rate .vjs-menu-item-text {
    font-size: 1em;
  }
  .vjs-menu li {
    font-size: 1em;
    color: inherit;
  }
  .vjs-menu li.vjs-selected {
    color: #222226;
  }
  .video-js .vjs-big-play-button {
    display: none;
  }
  .video-box {
    position: relative;
    width: 924px;

    .icon {
      width: 69px; // 对齐内置按钮
      height: 69px; // 对齐内置按钮
      margin-top: -12px; // 对齐内置按钮
      position: absolute;
      // transition: 0.1s all ease;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      // opacity: 0;
      cursor: pointer;
      z-index: 10;

      &.fade-in {
        opacity: 1;
        transition: opacity 1s;
      }

      &.fade-out {
        opacity: 0;
        transition: opacity 1s;
      }
    }

    .icon-video-play {
      display: inline-block;
      opacity: 1;
    }
  }
  .vjs-time-control {
    display: block;
  }
  .vjs-remaining-time {
    display: none;
  }
  .vjs-time-divider{
    padding: 0;
    min-width: 0;
  }

  .vjs-duration,.vjs-current-time{
    display: block !important;
  }
  .vjs-time-tooltip {
    background-color: rgb(51, 51, 51);
  }
}
</style>
